module.exports = __webpack_public_path__ + "img/bookshelf00.cb0be081.jpg";